import { t } from '@lingui/macro';

import { SortingTypes } from '@decisiv/ui-components/lib/components/Table';
import { Column } from '@decisiv/ui-components/lib/components/Table/types';

import { sortFactory } from 'utils/sortFactory';

import type { ManagedOemSegmentType } from '.';

import NameCell from './Cells/NameCell';
import IdCell from './Cells/IdCell';
import KeyCell from './Cells/KeyCell';
import TeamsCountCell from './Cells/TeamsCountCell';
import FleetsCountCell from './Cells/FleetsCountCell';
import AssetsCountCell from './Cells/AssetsCountCell';
import CreatedByCell from './Cells/CreatedByCell';
import CreatedAtCell from './Cells/CreatedAtCell';
import ManagersCell from './Cells/ManagersCell';

interface GenerateColumnsParams {
  onSort: (fieldName: string, direction: SortingTypes) => void;
}

export const generateColumns = ({ onSort }: GenerateColumnsParams) => {
  return [
    {
      name: 'name',
      title: t`OEM Segment Name`,
      DataCell: NameCell,
      sortBy: sortFactory('NAME', onSort),
    },
    {
      name: 'id',
      title: t`OEM Segment ID`,
      DataCell: IdCell,
      sortBy: sortFactory('ID', onSort),
    },
    {
      name: 'key',
      title: t`Segment Key`,
      DataCell: KeyCell,
      sortBy: sortFactory('SEGMENT_KEY', onSort),
    },
    {
      name: 'teams',
      title: t`Teams`,
      DataCell: TeamsCountCell,
      sortBy: sortFactory('TEAMS_COUNT', onSort),
    },
    {
      name: 'fleets',
      title: t`Accounts`,
      DataCell: FleetsCountCell,
      sortBy: sortFactory('FLEETS_COUNT', onSort),
    },
    {
      name: 'assets',
      title: t`Assets`,
      DataCell: AssetsCountCell,
      sortBy: sortFactory('ASSETS_COUNT', onSort),
    },
    {
      name: 'createdBy',
      title: t`Created by`,
      DataCell: CreatedByCell,
      sortBy: sortFactory('CREATED_BY', onSort),
    },
    {
      name: 'createdAt',
      title: t`Created on`,
      DataCell: CreatedAtCell,
      sortBy: sortFactory('CREATED_AT', onSort),
    },
    {
      name: 'admins',
      title: t`OEM Segment Admins`,
      DataCell: ManagersCell,
    },
  ] satisfies Column<ManagedOemSegmentType>[];
};
